<div class="container">
    <app-error-page [errorConfig]="errorObject"></app-error-page>
</div>
